import { render } from "./banner-cookies-v2.vue?vue&type=template&id=488c4362"
import script from "./banner-cookies-v2.vue?vue&type=script&lang=js"
export * from "./banner-cookies-v2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__